import React, { useState } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";

interface UserGroupInfoProps {
  user: {
    id?: string;
    super_admin?: boolean;
  };
  group: {
    id?: string;
    name?: string;
  };
  authSignedIn: boolean;
}

const UserGroupInfo: React.FC<UserGroupInfoProps> = ({
  user,
  group,
  authSignedIn,
}) => {
  const [copiedUserId, setCopiedUserId] = useState(false);
  
  const handleCopyUserId = () => {
    if (user.id) {
      navigator.clipboard.writeText(user.id);
      setCopiedUserId(true);
      setTimeout(() => setCopiedUserId(false), 2000);
    }
  };
  
  return (
    <Row>
      <Col md={6}>
        <Card>
          <Card.Header>
            <h4>👤 User Information</h4>
          </Card.Header>
          <Card.Body>
            <BlockyMediumText style={{ color: "#666" }}>User ID:</BlockyMediumText>
            <div className="d-flex align-items-center gap-2">
              <BlockyHeavyText style={{ fontFamily: "monospace" }}>
                {user.id || "Not logged in"}
              </BlockyHeavyText>
              {user.id && (
                <Button 
                  variant="outline-secondary" 
                  size="sm" 
                  onClick={handleCopyUserId}
                  style={{ marginLeft: "10px" }}
                >
                  {copiedUserId ? "Copied!" : "Copy"}
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col md={6}>
        <Card>
          <Card.Header>
            <h4>🏢 Group Information</h4>
          </Card.Header>
          <Card.Body>
            <BlockyMediumText style={{ color: "#666" }}>Group ID:</BlockyMediumText>
            <BlockyHeavyText style={{ fontFamily: "monospace" }}>
              {group.id || "No group loaded"}
            </BlockyHeavyText>
            {group.name && (
              <div className="mt-2">
                <BlockyMediumText style={{ color: "#666" }}>Group Name:</BlockyMediumText>
                <BlockyHeavyText>{group.name}</BlockyHeavyText>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default UserGroupInfo;